import { useCartManager } from "@/components/providers/CartProvider";

import CartIcon from "@/assets/icons/Buy shopping cart.svg?react";

export default function CartButton() {
  const { onToggleCart, totalCartItems } = useCartManager();

  return (
    <button
      type="button"
      onClick={onToggleCart}
      className="relative flex items-center justify-center w-9 h-9 bg-transparent border-none cursor-pointer p-0"
      aria-label={`Cart${totalCartItems > 0 ? `, ${totalCartItems} items` : ""}`}
    >
      <CartIcon width={24} height={24} />
      {totalCartItems > 0 && (
        <span className="absolute -top-0.5 -right-0.5 flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-brand-primary text-white text-[10px] font-bold leading-none">
          {totalCartItems}
        </span>
      )}
    </button>
  );
}
